import Vue from 'vue'
import App from './App.vue'
import VCalendar from 'v-calendar';
import VueObserveVisibility from 'vue-observe-visibility';


Vue.config.productionTip = false

Vue.use(VCalendar, {
  componentPrefix: 'vc',
});

Vue.use(VueObserveVisibility);

new Vue({
  render: h => h(App)
}).$mount('#app')
